// src/shared/components/MarkdownField/MarkdownPreview.tsx

import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import styles from './markdown-preview.module.css';

interface MarkdownPreviewProps {
  source: string;
  className?: string;
}

/**
 * Renders CommonMark Markdown as sanitized HTML.
 * Styling uses Mantine CSS variables for theme compatibility.
 */
export const MarkdownPreview = memo(function MarkdownPreview({
  source,
  className,
}: MarkdownPreviewProps) {
  return (
    <div className={`${styles.preview} ${className ?? ''}`}>
      <ReactMarkdown rehypePlugins={[rehypeSanitize]}>{source}</ReactMarkdown>
    </div>
  );
});
